import React from 'react';

const FacebookFrame = ({ post, title }) => {
    return (
        <iframe
            title={title}
            src={`https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Ftrinutspampanga%2Fposts%2F${post}&width=250`}
            width="100%"
            height="500"
            frameBorder="0"
            allow="encrypted-media">    
        </iframe>
    )
}

export default FacebookFrame;


